const inputChange = (value: number, isMin: boolean, currentValues: number[]) => {
  const inputValue = Number(value);

  if (isMin) {
    return [inputValue, currentValues[1]];
  } else {
    return [currentValues[0], inputValue];
  }
};

const inputBlur = (value: number, isMin: boolean, currentValues: number[], minValue: number, maxValue: number) => {
  const inputValue = Number(value);

  if (isMin) {
    const oldValue = currentValues[1];
    const newValue = inputValue < minValue || inputValue > maxValue ? minValue : inputValue;
    return [newValue, oldValue];
  } else {
    const oldValue = currentValues[0];
    const newValue = inputValue > maxValue || inputValue < minValue ? maxValue : inputValue;
    return [oldValue, newValue];
  }
};

export { inputChange, inputBlur };
